import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { navigateToManageStockDetails } from "../../../Navigation/Navigation";
import { Avatar } from "../../../components/Avatar/Avatar";
import {
  convertAmountLocal,
  getName,
  startApiCall,
} from "../../../global-functions/globalFunctions";
import { useSelector } from "react-redux";
import ApiCall from "../../../api/ApiCall";
import { InventoryRelatedEndPoints } from "../../../api/Endpoints";
import { toast } from "react-toastify";
import ConfirmModal from "../../../components/ConfirmationModal/ConfirmModal";

const RawMaterialTable = ({
  allMaterial,
  page,
  pageLimit,
  setEditMaterial,
  isModuleReadWriteAccessForRawMaterial,
  setisChangeStockModal,
  setselectedItem,
  stockType,
  handleGetAllMaterial,
}) => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [loader, setloader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [confirmAction, setConfirmAction] = useState("delete");

  const handleClose = () => {
    setIsOpen(false);
    setErrorMessage("");
    setloader(false);
    setSelectedMaterial(null);
  };

  const handleConfirmDeleteOrRecover = async (e) => {
    e?.preventDefault?.();
    startApiCall(setErrorMessage, setloader);
    const isRecover = confirmAction === "recover";
    const data = {
      inventoryId: selectedMaterial?._id,
      isDeleted: !isRecover,
      actionBy: user?._id,
    };
    const res = await ApiCall(
      "post",
      InventoryRelatedEndPoints.deleteInventory,
      data
    );
    if (res?.success) {
      handleClose();
      handleGetAllMaterial();
      toast.success(
        isRecover
          ? "Raw material recovered successfully!"
          : "Raw material deleted successfully!"
      );
    } else {
      setloader(false);
      setErrorMessage(res?.error);
    }
  };

  return (
    <>
      <div className="contact-list-view">
        <table id="datable_1" className="table nowrap w-100 mb-8">
          <thead>
            <tr className="text-center">
              <th>No .</th>
              <th style={{ textAlign: "left" }}>Name</th>
              <th>Status</th>
              <th>Code</th>
              <th>Category</th>
              <th>Current Stock</th>
              <th>Price / Unit</th>
              <th>Created By</th>
              {isModuleReadWriteAccessForRawMaterial && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {allMaterial?.map((inv, index) => {
              return (
                <tr className="text-center" key={inv?._id || index}>
                  <td>{(page - 1) * pageLimit + (index + 1)} .</td>
                  <td style={{ textAlign: "left" }}>
                    <span
                      className="text-capitalize text-truncate text-link"
                      style={{ width: "300px" }}
                      onClick={() => {
                        if (inv?.isDeleted) return;
                        localStorage.setItem("rawMaterialPage", page);
                        localStorage.setItem("rawMaterialPageLimit", pageLimit);
                        navigate(
                          navigateToManageStockDetails({ id: inv?._id }),
                          {
                            state: {
                              name: inv?.name,
                              code: inv?.inventoryItemCode,
                              unit: inv?.unit?.name,
                              unitId: inv?.unit?._id,
                            },
                          }
                        );
                      }}
                    >
                      {inv?.name}
                    </span>
                  </td>
                  <td>
                    {inv?.isDeleted ? (
                      <span className="badge badge-pill badge-danger">
                        Deleted
                      </span>
                    ) : inv?.currentStock <= inv?.lowInventoryCount ? (
                      <span className="badge badge-pill badge-danger pulse">
                        Low
                      </span>
                    ) : (
                      <span
                        style={{ backgroundColor: "#07bc0c" }}
                        className="badge badge-pill badge-success"
                      >
                        IN
                      </span>
                    )}
                  </td>

                  <td> {inv?.inventoryItemCode}</td>

                  <td>{inv?.category}</td>
                  <td>
                    <div className="d-flex justify-content-evenly pointer">
                      {!inv?.isDeleted &&
                        isModuleReadWriteAccessForRawMaterial && (
                          <span
                            onClick={() => {
                              setisChangeStockModal("out");
                              setselectedItem(inv);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#change_stock"
                            className="border px-2 me-2 bg-danger"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              fill="#FFFFFF"
                              className="bi bi-dash-lg mb-1"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"
                              />
                            </svg>
                          </span>
                        )}
                      <p className="w-100p text-primary fw-semibold">
                        {inv?.currentStock?.toFixed(2)}
                      </p>
                      {!inv?.isDeleted &&
                        isModuleReadWriteAccessForRawMaterial && (
                          <span
                            onClick={() => {
                              setisChangeStockModal("in");
                              setselectedItem(inv);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#change_stock"
                            className="border px-2 ms-2 bg-success"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              fill="#FFFFFF"
                              className="bi bi-plus-lg mb-1"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                              />
                            </svg>
                          </span>
                        )}
                    </div>
                  </td>
                  <td className="text-dark">
                    <span className="font-mon font-3">
                      {convertAmountLocal(inv?.costPricePerUnit) || "NA"}
                    </span>{" "}
                    /
                    <span className="font-2 text-secondary">
                      {inv?.unit?.name}
                    </span>
                  </td>
                  <td>
                    {inv?.createdBy ? (
                      <>
                        <Avatar
                          name={inv?.createdBy?.name}
                          count={1}
                          image={inv?.createdBy?.image}
                          size="xxs"
                          color="primary"
                        />
                        &nbsp;
                        {getName(inv?.createdBy, user?._id)}
                      </>
                    ) : (
                      "-"
                    )}
                  </td>

                  {isModuleReadWriteAccessForRawMaterial && (
                    <td>
                      <span className="feather-icon pointer">
                        <i
                          data-bs-toggle="dropdown"
                          role="button"
                          aria-haspopup="true"
                          aria-expanded="false"
                          className="ri-more-fill"
                        ></i>
                        <div className="dropdown-menu">
                          {!inv?.isDeleted && (
                            <div
                              className="dropdown-item d-flex align-items-center"
                              data-bs-toggle="modal"
                              data-bs-target="#add_raw_material"
                              onClick={() => {
                                setEditMaterial(inv);
                              }}
                            >
                              <span className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover del-button text-primary">
                                <span className="btn-icon-wrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-pencil-square"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                    />
                                  </svg>
                                </span>
                              </span>
                              <p>Edit</p>
                            </div>
                          )}
                          {inv?.isDeleted ? (
                            <div
                              className="dropdown-item d-flex align-items-center"
                              onClick={() => {
                                setConfirmAction("recover");
                                setSelectedMaterial(inv);
                                setIsOpen(true);
                              }}
                            >
                              <span className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover del-button text-success">
                                <span className="btn-icon-wrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-arrow-counterclockwise"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M8 3a5 5 0 1 1-4.546 10.093.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
                                    />
                                    <path d="M8 4.466V.534a.25.25 0 0 0-.41-.212L5.1 2.288a.25.25 0 0 0 0 .424l2.49 1.966A.25.25 0 0 0 8 4.466" />
                                  </svg>
                                </span>
                              </span>
                              <p>Recover</p>
                            </div>
                          ) : (
                            <div
                              className="dropdown-item d-flex align-items-center"
                              onClick={() => {
                                setConfirmAction("delete");
                                setSelectedMaterial(inv);
                                setIsOpen(true);
                              }}
                            >
                              <span className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover del-button text-danger">
                                <span className="btn-icon-wrap">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-trash"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                  </svg>
                                </span>
                              </span>
                              <p>Delete</p>
                            </div>
                          )}
                        </div>
                      </span>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ConfirmModal
        isOpen={isOpen}
        onClose={handleClose}
        text={
          confirmAction === "recover"
            ? "Are you sure you want to recover this raw material?"
            : "Are you sure you want to delete this raw material?"
        }
        loader={loader}
        errorMessage={errorMessage}
        handleConfirm={handleConfirmDeleteOrRecover}
      />
    </>
  );
};

export default RawMaterialTable;
